import { createFileRoute, redirect } from "@tanstack/react-router";

import type { QueryClient } from "@tanstack/react-query";

import { creativeBlocksQueryOptions } from "@/api/creative-blocks";
import { ErrorComponent } from "@/components/ErrorComponent";
import { LoadingFallback } from "@/components/LoadingFallback";
import { BlockLibrary } from "@/features/BlockLibrary/BlockLibrary";
import { isSavedBlockTypesEnabledForSite } from "@/features/BlockLibrary/flag";

export const Route = createFileRoute("/_auth/blocks/$siteId")({
  beforeLoad: ({ params }) => {
    if (!isSavedBlockTypesEnabledForSite(params.siteId)) {
      throw redirect({
        to: "/creative-sphere/$siteId",
        params: { siteId: params.siteId },
      });
    }
  },
  loader: ({ params, context }) => {
    const { queryClient } = context as { queryClient: QueryClient };
    void queryClient.prefetchQuery(creativeBlocksQueryOptions(params.siteId));
  },
  component: RouteComponent,
  pendingComponent: LoadingFallback,
  errorComponent: ErrorComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  return <BlockLibrary siteId={siteId} />;
}
